import { BaseApi as Base } from '@micromag/data';

class AuthApi extends Base {
    check() {
        return this.requestGet(this.route('auth.check'));
    }

    login(email, password) {
        return this.requestPost(this.route('auth.login'), {
            email,
            password,
        });
    }

    forgotPassword(email) {
        return this.requestPost(this.route('password.email'), {
            email,
        });
    }

    resetPassword(email, token, data) {
        return this.requestPost(this.route('password.update'), {
            email,
            token,
            ...data,
        });
    }

    logout() {
        return this.requestPost(this.route('auth.logout'));
    }
}

export default AuthApi;
